// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__I5ZXB","content":"styles_content__mVv2Y"};